import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { IFontsLoadingState, IFontsStatusNotifier, ViewerManagerFontsApiEditorConfig } from './types'
import { FontsLoadingStateSymbol, FontsStatusNotifierSymbol, name } from './symbols'

export const ViewerManagerFontsApi = withDependencies(
	[named(EditorFeatureConfigSymbol, name), FontsLoadingStateSymbol, FontsStatusNotifierSymbol],
	(
		config: ViewerManagerFontsApiEditorConfig,
		featureState: IFontsLoadingState,
		fontsStatusNotifier: IFontsStatusNotifier
	): IViewerManagerImplementor<'fonts'> => {
		return {
			fonts: {
				hasPendingFonts: fontsStatusNotifier.hasPendingFonts,
				getCompsWaitingForFonts: () => ({}), // not used by dm. will be used for debug purposes or removed entirely
			},
		}
	}
)
